import React from "react";
import Grid from "@material-ui/core/Grid";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import { FormattedMessage, IntlProvider } from "react-intl";
import DefaultComp from "../../../Component/DefaultComp/Defaultstatecomp";
import defaultstateimg from "../../../Assets/Svg/group-4.svg";

class Help extends React.Component {
  render() {
    return (
      <IntlProvider locale="en" messages={""}>
        <main className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Help.header}</title>
        </Helmet>
          <Grid container className="position-rel">
            <Grid item xs={12} md={12} sm={12}>
              <DefaultComp
                //  text={this.getText()}
                heading={<FormattedMessage id="conceptbucreate" defaultMessage="sumHR Helpdesk" />}
                subheading={
                  <FormattedMessage
                    id="#"
                    defaultMessage="Advice, answers and assistance from the sumHR team."
                  />
                }
                // onCreate={this._onCreate}
                imageSrc={defaultstateimg}
              />
            </Grid>
          </Grid>
        </main>
      </IntlProvider>
    );
  }
}

export default Help;
